import React, {Fragment, useContext} from 'react';
import Tarea from './Tarea';
import proyectoContext from '../../context/proyectos/proyectoContext';
import TareaContext from '../../context/tareas/tareaContext';
import {CSSTransition, TransitionGroup} from 'react-transition-group';

const ListadoTareas = () => {

    //extraer proyectos del state inicial
    const proyectosContext = useContext(proyectoContext);
    const {proyecto,eliminarProyecto} =proyectosContext;

    //obtener las tareas del proyecto
    const TareasContext =useContext(TareaContext);
    const {tareasproyecto} =TareasContext;
    

    //si no hay proyecto seleccionado 
    if(!proyecto)return <h2>Selecciona un proyecto</h2>

    //array destructuring para extraer el proyecto actual
    const [proyectoActual]= proyecto;

    

    const onClickEliminar =()=>{
        eliminarProyecto(proyectoActual._id);
    }
    return ( 
        <Fragment>
            <h2>Proyecto: {proyectoActual.nombre}</h2>
            <ul className="listado-tareas">
                {tareasproyecto.length === 0
                    ? <li className="tarea"><p>No hay tareas</p></li>
                
                    : <TransitionGroup>
                        {tareasproyecto.map(tarea=>(
                            <CSSTransition
                                key={tarea._id}
                                timeout={4000}
                                classNames="tarea"
                            >
                                <Tarea
                                    tarea={tarea}
                                />
                            </CSSTransition>

                         ))}
                    </TransitionGroup>
                } 
            </ul>
            <button
                type="text"
                className="btn btn-eliminar"
                onClick={()=>onClickEliminar()}
            >Eliminar Proyecto &times;</button>
        </Fragment>
     );
}
 
export default ListadoTareas;